import {  useQuery,useQueryClient,useMutation  } from '@tanstack/react-query';
import { fetchWholesaleInventoryDetails,createWholesaleInventory,downloadWholesaleInventory } from './wholesaleinventory.api';

  export function useInventroyDetails() {
    return useQuery({
      queryKey: ['wholesale-inventory-details'],
      queryFn: () => fetchWholesaleInventoryDetails(),
      keepPreviousData: true
    });
  }
  export const useCreateWholesaleInventory = (onSuccess, onError) => {
    return useMutation({
      mutationFn: createWholesaleInventory,
      onSuccess,
      onError,
    });
  };


  export const useDownloadWholesaleInventory = () =>
    useMutation({
      mutationFn: downloadWholesaleInventory
    });

  
